import React, { useState } from "react";
import { useQuery, useMutation } from "@apollo/client";
import { useParams } from "react-router-dom";
import Spinner from "./Spinner";
import GetUser from "../queries/GetUser";
import AddSurveyToUser from "../mutations/AddSurveyToUser";
import DeleteSurveyFromUser from "../mutations/DeleteSurveyFromUser";
import AddMultipleSurveys from "../mutations/AddMultipleSurveys";
import UpdatePassword from "../mutations/UpdatePassword";
// reactstrap
import {
  Form,
  FormGroup,
  Button,
  Card,
  CardBody,
  CardHeader,
  Row,
  Col,
  Table,
  Modal,
  Input,
} from "reactstrap";
import Select from "react-select";

const UserDetails = () => {
  const params = useParams();
  const { loading, error, data } = useQuery(GetUser, {
    variables: { userId: params.userId },
  });
  const [title, setTitle] = useState("");
  const [surveyType, setSurveyType] = useState("imi");
  const [errors, setErrors] = useState([]);
  const [passwordErrors, setPasswordErrors] = useState([]);
  const [selectedTitleType, setSelectedTitleType] = useState(null);
  const [selectedSurveyType, setSelectedSurveyType] = useState(null);

  const [deleteSurveyMutation] = useMutation(DeleteSurveyFromUser);
  const [addSurveyMutation] = useMutation(AddSurveyToUser);
  const [AddMultiple] = useMutation(AddMultipleSurveys);
  const [UpdatePasswordMutation] = useMutation(UpdatePassword);
  const [password, setPassword] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [variablesForModalClose, setVariablesForModalClose] = useState(null);

  const surveyList = [
    {
      title: "Course II, <language> - Course Introduction",
      survey_type: "introduction",
    },
    {
      title: "Course II, <language> Module 1 - Security Assistance Issues",
      survey_type: "imi",
    },
    {
      title:
        "Course II, <language> Module 1 Assessment - Security Assistance Issues",
      survey_type: "assessment",
    },
    {
      title: "Course II, <language> Module 2 - Multilateral Organizations",
      survey_type: "imi",
    },
    {
      title:
        "Course II, <language> Module 2 Assessment - Multilateral Organizations",
      survey_type: "assessment",
    },
    {
      title: "Course II, <language> Module 3 - Aviation Issues",
      survey_type: "imi",
    },
    {
      title: "Course II, <language> Module 3 Assessment - Aviation Issues",
      survey_type: "assessment",
    },
    {
      title: "Course II, <language> Module 4 - Environmental Issues",
      survey_type: "imi",
    },
    {
      title: "Course II, <language> Module 4 Assessment - Environmental Issues",
      survey_type: "assessment",
    },
    {
      title: "Course II, <language> Module 5 - Foreign Aid & Investment",
      survey_type: "imi",
    },
    {
      title:
        "Course II, <language> Module 5 Assessment - Foreign Aid & Investment",
      survey_type: "assessment",
    },
    {
      title: "Course II, <language> Module 6 - Popular Culture",
      survey_type: "imi",
    },
    {
      title: "Course II, <language> Module 6 Assessment - Popular Culture",
      survey_type: "assessment",
    },
    {
      title: "Course II, <language> - Posttest",
      survey_type: "posttest",
    },
  ];

  const handleMutation = (mutationType, variables) => {
    if (mutationType === "delete") {
      deleteSurveyMutation({
        variables,
        refetchQueries: [
          { query: GetUser, variables: { userId: params.userId } },
        ],
      })
        .then((result) => console.log("Delete Mutation result: ", result))
        .catch((error) => console.log("Delete Mutation error: ", error));
    } else if (mutationType === "add") {
      addSurveyMutation({
        variables,
        refetchQueries: [
          { query: GetUser, variables: { userId: params.userId } },
        ],
      })
        .then((result) => console.log("Add Mutation result: ", result))
        .catch((error) => console.log("Add Mutation error: ", error));
    } else if (mutationType === "multiple") {
      console.log("trying to run with: ", variables);
      return AddMultiple({
        variables,
        refetchQueries: [
          { query: GetUser, variables: { userId: params.userId } },
        ],
      })
        .then((result) => console.log("Add multiple surveys result: ", result))
        .catch((error) => console.log("Add multiple surveys error: ", error));
    } else if (mutationType === "password") {
      UpdatePasswordMutation({ variables })
        .then((result) => {
          setPassword("");
          console.log("Password Update result: ", result);
        })
        .catch((error) => {
          setPassword("");
          console.log("Password Update error: ", error);
        });
    }
  };

  if (loading) return <Spinner />;
  if (error) {
    console.log("error:");
    console.log(error);
    return <p>Something Went Wrong...</p>;
  }

  const { user } = data;

  function handleConfirm(choice) {
    setShowModal(false);

    if (choice) {
      handleMutation("multiple", variablesForModalClose).then(() => {
        setVariablesForModalClose(null);
      });
    }
  }

  function submitPassword() {
    let newErrors = [];

    if (password === "") {
      newErrors.push("Please input something for a password");
    }

    setPasswordErrors(newErrors);

    if (newErrors.length === 0) {
      const variables = {
        userId: params.userId,
        password,
      };

      handleMutation("password", variables);
    }
  }

  function onSubmit() {
    let newErrors = [];

    if (title === "") {
      newErrors.push("please input something into title");
    }

    setErrors(newErrors);

    if (newErrors.length === 0) {
      const capitalizedSurveyLanguage =
        user.survey_language.charAt(0).toUpperCase() +
        user.survey_language.slice(1);

      const variables = {
        userId: params.userId,
        title: title.replace("<language>", capitalizedSurveyLanguage),
        survey_type: surveyType,
        trial_type: user.trial_type,
        survey_language: capitalizedSurveyLanguage,
      };

      handleMutation("add", variables);
    }
  }

  function submitAll() {
    const capitalizedSurveyLanguage =
      user.survey_language.charAt(0).toUpperCase() +
      user.survey_language.slice(1);

    const modifiedSurveys = surveyList.map((survey) => ({
      title: survey.title.replace("<language>", capitalizedSurveyLanguage),
      survey_type: survey.survey_type,
      trial_type: user.trial_type,
      survey_language: user.survey_language,
    }));

    const variables = {
      userId: params.userId,
      surveys: modifiedSurveys,
    };

    // handleMutation("multiple", variables)
    setShowModal(true);
    setVariablesForModalClose(variables);
  }

  function deleteSurvey(surveyId) {
    console.log("trying to delete survey ", surveyId);
    const variables = {
      userId: params.userId,
      surveyId: surveyId,
    };
    handleMutation("delete", variables);
  }

  function displayDate(date) {
    if (date == null) {
      return;
    }

    // parse the time stored
    const parsedDate = JSON.parse(date);
    // convert the string to a date
    const actualDate = new Date(parsedDate);
    // check if time is anythng other than 1... time is # of seconds since Jan 1 1970, no reason for it to be 1 but it will be 1 if failing
    if (actualDate.getTime() === 1) {
      return;
    }
    // reached here because it has been completed and has valid date
    return `${
      actualDate.getUTCMonth() + 1
    }/${actualDate.getUTCDate()}/${actualDate.getFullYear()}`;
  }

  function displaySurvey(survey) {
    const completed_date = displayDate(survey.completed_date);
    const in_progress =
      displayDate(user.section_1_completed_date) ||
      displayDate(survey.section_2_completed_date);

    let status = "Not Started";
    if (completed_date != null) {
      status = `Was completed on ${completed_date}`;
    } else if (in_progress) {
      status = "Survey has been started";
    }

    return (
      <tr key={survey.id}>
        <td>{survey.title}</td>
        <td>{status}</td>
        <td>
          <i
            className="material-icons"
            onClick={() => {
              deleteSurvey(survey.id);
            }}
            style={{ cursor: "pointer" }}
          >
            delete
          </i>
        </td>
      </tr>
    );
  }

  function displaySurveys() {
    if (user.surveys.length === 0) {
      return (
        <div className="d-flex flex-column p-5 my-5 h-100 w-100 justify-content-center align-items-center">
          <h1>
            <i className="ni ni-bell-55 text-muted" />
          </h1>
          <h3 className="text-muted">No Surveys Assigned</h3>
        </div>
      );
    }

    return (
      <Table responsive striped>
        <thead className="table-dark">
          <tr>
            <th scope="col">Title</th>
            <th scope="col">Status</th>
            <th scope="col">Delete</th>
          </tr>
        </thead>
        <tbody>
          {user.surveys.map((survey) => {
            return displaySurvey(survey);
          })}
        </tbody>
      </Table>
    );
  }

  const colors = [
    "Red",
    "Blue",
    "Green",
    "Yellow",
    "Orange",
    "Purple",
    "Pink",
    "Teal",
    "Coral",
    "Cyan",
  ];
  const animals = [
    "Dog",
    "Cat",
    "Bird",
    "Fish",
    "Rabbit",
    "Turtle",
    "Horse",
    "Mouse",
    "Duck",
    "Goat",
    "Cow",
    "Pig",
    "Lion",
    "Monkey",
    "Bear",
    "Deer",
    "Sheep",
    "Fox",
    "Wolf",
    "Zebra",
  ];

  const generatePassword = () => {
    const randomColor = colors[Math.floor(Math.random() * colors.length)];
    const randomAnimal = animals[Math.floor(Math.random() * animals.length)];
    const generated = randomColor + randomAnimal;

    console.log("trying to generate: ", generated);
    setPassword(generated);
  };

  return (
    <>
      <Row>
        <Col className="order-xl-2 mb-5 mb-xl-0" xl="4">
          <Card className="bg-secondary shadow">
            <CardHeader className="bg-white border-0">
              <Row className="align-items-center">
                <Col>
                  <h3 className="mb-0">Add Survey</h3>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Form>
                <h6 className="heading-small text-muted mb-4">
                  Survey Details
                </h6>
                <Row>
                  <Col lg="6" xl="12">
                    <FormGroup>
                      <label
                        className="form-control-label"
                        htmlFor="input-title"
                      >
                        Title
                      </label>
                      <Select
                        onChange={(thisData) => {
                          console.log("thisData: ", thisData);
                          setSelectedTitleType(thisData);
                          setTitle(thisData.value);
                        }}
                        value={selectedTitleType}
                        options={surveyList.map((survey) => ({
                          label: survey.title, // Set label to survey's title
                          value: survey.title, // Set value to survey's title as well
                        }))}
                        className="form-control-alternative"
                        id="input-title"
                        placeholder="Title..."
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="6" xl="12">
                    <FormGroup>
                      <label
                        className="form-control-label"
                        htmlFor="input-type"
                      >
                        Type
                      </label>
                      <Select
                        onChange={(selectedSurveyType) => {
                          setSelectedSurveyType(selectedSurveyType);
                          setSurveyType(selectedSurveyType.value);
                        }}
                        value={selectedSurveyType}
                        options={[
                          {
                            label: "IMI",
                            value: "imi",
                          },
                          {
                            label: "Assessment",
                            value: "assessment",
                          },
                          {
                            label: "Posttest",
                            value: "posttest",
                          },
                          {
                            label: "Introduction",
                            value: "introduction",
                          },
                        ]}
                        className="form-control-alternative"
                        id="input-type"
                        placeholder="Type..."
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <div className="errors">
                  {errors.map((error) => (
                    <div key={error}>{error}</div>
                  ))}
                </div>
                <hr className="my-4" />
                <Button
                  color="primary"
                  onClick={(e) => {
                    e.preventDefault();
                    onSubmit();
                  }}
                >
                  Submit
                </Button>
                <Button
                  color="primary"
                  onClick={(e) => {
                    e.preventDefault();
                    submitAll();
                  }}
                >
                  Submit Defaults
                </Button>
              </Form>
            </CardBody>
          </Card>
        </Col>
        <Col className="order-xl-2 mb-5 mb-xl-0" xl="4">
          <Card className="bg-secondary shadow">
            <CardHeader className="bg-white border-0">
              <Row className="align-items-center">
                <Col>
                  <h3 className="mb-0">Password Control</h3>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Form>
                <h6 className="heading-small text-muted mb-4">
                  Password Control
                </h6>
                <Row>
                  <Col lg="8">
                    <FormGroup>
                      <label
                        className="form-control-label"
                        htmlFor="input-password"
                      >
                        Password
                      </label>
                      <Input
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="form-control-alternative"
                        id="input-password"
                        placeholder="Password"
                        type="text"
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <div className="errors">
                  {passwordErrors.map((error) => (
                    <div key={error}>{error}</div>
                  ))}
                </div>
                <hr className="my-4" />
                <Button
                  color="primary"
                  onClick={(e) => {
                    e.preventDefault();
                    submitPassword();
                  }}
                >
                  Update Password
                </Button>
                <Button
                  color="primary"
                  onClick={(e) => {
                    e.preventDefault();
                    generatePassword();
                  }}
                >
                  Select Random Password
                </Button>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Col className="order-xl-1" xl="8">
        <Card className="shadow-lg" style={{ minHeight: "100%" }}>
          <CardHeader className="d-flex justify-content-between align-items-center">
            <h3 className="mb-0">Current Surveys</h3>
          </CardHeader>
          <CardBody className="p-0 h-100">{displaySurveys()}</CardBody>
        </Card>
      </Col>
      <Modal
        className="modal-dialog-centered"
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
      >
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            Submit Completed Survey
          </h5>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => setShowModal(false)}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body">
          You are about to add ALL default surveys to this user. Are you sure
          you want to do this? If you've already added a survey then you risk
          duplicates.
        </div>
        <div className="modal-footer">
          <Button color="secondary" onClick={() => handleConfirm(false)}>
            Cancel
          </Button>
          <Button color="primary" onClick={() => handleConfirm(true)}>
            Continue
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default UserDetails;
